<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>消息管理</el-breadcrumb-item>
        <el-breadcrumb-item>消息列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="发送状态：">
              <el-select clearable size="small" v-model="listParams.status" style="width: 100%">
                <el-option v-for="item in statusList" :label="item.title" :value="item.id" :key="item.title"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="toCreate"> 新增 </el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column align="center" type="selection" width="55"> </el-table-column>

        <el-table-column prop="systemMessageId" align="center" label="id"> </el-table-column>

        <el-table-column prop="title" align="center" label="消息标题"> </el-table-column>

        <el-table-column prop="publishStatus" align="center" label="发送状态">
          <template slot-scope="scope">
            <span v-if="scope.row.publishStatus === 0">未发送</span>
            <span v-if="scope.row.publishStatus === 1">已发送</span>
          </template>
        </el-table-column>

        <el-table-column prop="publisher" align="center" label="操作人"> </el-table-column>

        <el-table-column prop="publishDate" align="center" label="发送时间">
          <template slot-scope="scope">
            <span v-if="scope.row.publishDate">
              {{ scope.row.publishDate | formatDate }}
            </span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(scope.row.systemMessageId)">
              <span>删除</span>
            </confirm-button>

            <confirm-button v-if="!scope.row.publishDate" type="text" style="margin: 0 10px" title="确认要发送该条数据？" @confirmed="publishItem(scope.row.systemMessageId)">
              <span>发送</span>
            </confirm-button>

            <confirm-button v-if="scope.row.publishDate" type="text" style="margin: 0 10px" title="确认要再次发送该条数据？" @confirmed="republishItem(scope.row)">
              <span>再次发送</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="70%" @close="resetDialogForm" :close-on-click-modal="false">
      <div>
        <el-form ref="dialogForm" :model="itemParams" :rules="checkItemParams" label-width="120px">
          <el-form-item label="消息标题 ：" prop="title">
            <el-input v-model="itemParams.title" size="small" placeholder="请输入消息标题"> </el-input>
          </el-form-item>

          <el-form-item label="消息详情：" prop="content" style="height: 430px">
            <RichTextarea v-if="dialogVisible" class="wang-editor-style" v-model="itemParams.content" height="340px" />
          </el-form-item>

          <el-form-item>
            <el-button :disabled="isDisabled" size="small" type="primary" @click="saveMessage('dialogForm')"> 保 存 </el-button>

            <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        status: "",
      },
      statusList: [
        { id: "", title: "全部" },
        { id: "1", title: "已发送" },
        { id: "0", title: "未发送" },
      ],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dialogTitle: "",
      dialogVisible: false,
      itemParams: {
        title: "",
        content: "",
      },
      bodyParams: {},
      method: "",
      url: "",
      checkItemParams: {
        title: [{ required: true, message: "请输入消息标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入消息内容", trigger: "blur" }],
      },
      isDisabled: false,
    };
  },
  mounted() {
    this.loadCategoryList();
    this.loadTableData();
  },
  methods: {
    /**
     * 初始化加载分类名称
     */
    loadCategoryList() {
      this.$http({
        url: global.apiUrl + "/good/goodcategory/findAll",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            const dataList = res.body.data;
            dataList.unshift({ id: "", title: "全部" });
            this.categoryNameList = dataList;
          } else {
            this.categoryNameList = [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/msg/query",
        method: "GET",
        params: {
          status: this.listParams.status,
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 新增分类管理
     */
    toCreate() {
      this.dialogTitle = "新增消息";
      this.dialogVisible = true;
      this.method = "POST";
      this.url = "/msg/save";
      this.itemParams.title = "";
      if (this.itemParams.systemMessageId) {
        delete this.itemParams.systemMessageId;
      }
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 保存新增或修改
     * @param name
     */
    saveMessage(name) {
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$http({
            url: global.apiUrl + this.url,
            method: this.method,
            body: this.itemParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.isDisabled = false;
                this.dialogVisible = false;
                this.$message.success(res.body.info);
                this.loadTableData();
              } else {
                this.isDisabled = false;
              }
            })
            .catch(err => {
              console.error(err);
            });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.itemParams.title = "";
      this.itemParams.content = "";
      this.$refs.dialogForm.resetFields();
    },
    /**
     * 修改条目数据
     * @param row
     */
    editItem(row) {
      this.dialogTitle = "编辑消息";
      const itemParams = {};
      itemParams.systemMessageId = row.systemMessageId;
      itemParams.title = row.title;
      itemParams.content = row.content;
      this.itemParams = itemParams;
      this.dialogVisible = true;
      this.method = "PUT";
      this.url = "/msg/update";
    },
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/msg/delete?id=" + id,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 发送条目数据
     * @param id
     */
    publishItem(id) {
      this.$http({
        url: global.apiUrl + "/msg/publish?id=" + id,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 在此发送条目数据
     * @param row
     */
    republishItem(row) {
      this.$http({
        url: global.apiUrl + "/msg/republish",
        method: "PUT",
        body: {
          systemMessageId: row.systemMessageId,
          title: row.title,
          content: row.content,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
  .wang-editor-style {
    width: 100%;
  }
}
</style>
